import React, { ReactNode } from "react";
import { ShieldCheck } from "lucide-react";

interface DeviceShowcaseProps {
  desktopUI: ReactNode;
  mobileUI: ReactNode;
}

export default function DeviceShowcase({
  desktopUI,
  mobileUI,
}: DeviceShowcaseProps) {
  return (
    <div className="w-full h-full relative group">
      {/* Desktop Mockup */}
      <div className="absolute inset-0 bg-slate-100 border border-slate-200 rounded-[1.5rem] flex flex-col shadow-xl overflow-hidden transition-transform duration-500 origin-top-left md:w-[90%] md:h-[90%] w-[85%] h-[85%]">
        {/* Browser Header */}
        <div className="flex items-center gap-2 px-3 py-2 border-b border-slate-200 bg-white/50 backdrop-blur-sm z-10">
          <div className="flex gap-1.5 shrink-0">
            <div className="w-3 h-3 rounded-full bg-red-400"></div>
            <div className="w-3 h-3 rounded-full bg-amber-400"></div>
            <div className="w-3 h-3 rounded-full bg-green-400"></div>
          </div>
          <div className="flex-1 px-4 py-1.5 bg-white/80 rounded-md text-[10px] md:text-xs text-slate-400 font-mono shadow-sm border border-slate-200 flex items-center justify-center gap-2 max-w-sm mx-auto">
            <ShieldCheck className="w-3 h-3 text-green-500" />
            apv.gpems.net
          </div>
        </div>
        {/* Desktop Content */}
        <div className="flex-1 w-full bg-slate-50 overflow-hidden relative flex flex-col">
          {desktopUI}
        </div>
      </div>

      {/* Mobile Mockup */}
      <div className="absolute -bottom-2 -right-2 md:bottom-2 md:right-2 w-[140px] md:w-[180px] aspect-[9/19.5] bg-slate-900 border-[6px] border-slate-800 rounded-[2rem] shadow-2xl overflow-hidden z-20 flex flex-col transition-transform duration-500 group-hover:-translate-y-2 group-hover:-translate-x-2">
        {/* Mobile Notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-4 bg-slate-800 rounded-b-xl z-30"></div>
        {/* Mobile Content */}
        <div className="flex-1 w-full bg-slate-50 relative overflow-hidden flex flex-col">
          {mobileUI}
        </div>
        {/* Home Indicator */}
        <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-1/3 h-1 bg-slate-300 rounded-full z-30 pointer-events-none"></div>
      </div>
    </div>
  );
}
